// extracted by mini-css-extract-plugin
export default {"container":"Range_container__dCR4F","max":"Range_max__BvR5N","min":"Range_min__cpE7B"};